import React, { Component } from 'react'
import { TableComp } from 'sz-react-utils-lite'
import { connect } from 'react-redux'
import {
  DefaultTablePagination, displayDate, fixed2Digit
} from '../../../components/_utils/appUtils'
import { ColumnWidth } from '../../WebComponent/columnWidth'
import { getXTravelProfitAndLossFxn } from '../actions'
import { Button, Col, DatePicker, Row } from 'antd'
import AgentTypeheadComponent from '../../../components/_utils/AgentTypeheadComponent'
import { getUrlPushWrapper } from '../../../routes/routes'
import moment from 'moment'

const { RangePicker } = DatePicker

class xTravelWorldProfitAndLoss extends Component {

  events = {
    showUserRightDrawer: (data) => {
      this.setState({
        visibleUserRightDrawer: true,
        selectedUser: data
      })
    },
    hideUserRightDrawer: () => {
      this.setState({
        visibleUserRightDrawer: false,
        selectedUser: {}
      })
    },
    closeAndUpdateUserRightDrawer: () => {
      this.setState({
        visibleUserRightDrawer: false,
        selectedUser: {}
      }, () => {
        this.tableRef.current.reload()
      })
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      viewInfoDrawer: false,
      selectedRow: {},
      allAgents: [],
      allBranchManager: [],
      allCountry: [],
      selectedUser: {},
      agentId: '',
      filterAgentId: '',
      fromDate: null,   // changed from '' to null
      toDate: null      // changed from '' to null
    }
    this.tableRef = React.createRef()
  }

  componentDidMount() {

    setTimeout(() => {
      const el = document.getElementById('creditLimitTable')
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    }, 1000)
  }


  render() {
    let { total } = this.state

    const FlightNonStopComponent = (props) => {
      const { data } = props
      const { Segments, FareRules: fareRules } = data
      const allSegmentData = Segments[0]
      const segmentStarting = allSegmentData[0]
      const lastSegment = allSegmentData[allSegmentData.length - 1]

      return (
        <div
          className='d-flex align-items-center justify-content-center'
          style={{
            background: 'linear-gradient(90deg, #d0f0fd 0%, #f3d9fa 100%)',
            padding: '10px 20px',
            borderRadius: '16px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
          }}
        >
          <div className='text-center me-3'>
            <h6 className='mb-0 fw-bold' style={{ color: '#007bff', fontSize: '12px' }}>
              {(segmentStarting && segmentStarting.Origin && segmentStarting.Origin.Airport && segmentStarting.Origin.Airport.AirportCode) || ''}
            </h6>
            <small className='d-block text-muted' style={{ fontSize: '11px' }}>
              {(segmentStarting && segmentStarting.Origin && segmentStarting.Origin.Airport && segmentStarting.Origin.Airport.CityName) || ''}
            </small>
          </div>

          <div style={{ padding: '6px 12px', background: '#ffe9c5', borderRadius: '12px', margin: '0 15px' }}>
            <h6 style={{ fontSize: '12px', color: '#ff7a00', marginBottom: '4px', textAlign: 'center' }}>
              Non-Stop
            </h6>
          </div>

          <div className='text-center ms-3'>
            <h6 className='mb-0 fw-bold' style={{ color: '#28a745', fontSize: '12px' }}>
              {(lastSegment && lastSegment.Destination && lastSegment.Destination.Airport && lastSegment.Destination.Airport.AirportCode) || ''}
            </h6>
            <small className='d-block text-muted' style={{ fontSize: '11px' }}>
              {(lastSegment && lastSegment.Destination && lastSegment.Destination.Airport && lastSegment.Destination.Airport.CityName) || ''}
            </small>
          </div>
        </div>
      )
    }
    const FlightStopsComponent = (props) => {
      const { data } = props
      const Segments = data.Segments
      const fareRules = data.FareRules
      const allSegmentData = Segments[0]
      const segmentStarting = allSegmentData[0]
      const lastSegment = allSegmentData[allSegmentData.length - 1]
      const originObj = fareRules[0]
      const destinationObj = fareRules[fareRules.length - 1]

      const stopsComponent = (
        <div style={{ padding: '6px 12px', background: '#ffe9c5', borderRadius: '12px', margin: '0 15px' }}>
          <h6 style={{ fontSize: '12px', color: '#ff7a00', marginBottom: '4px', textAlign: 'center' }}>
            {allSegmentData.length - 1} Stop(s)
          </h6>
          <small style={{ fontSize: '10px', color: '#6c757d', display: 'block', textAlign: 'center' }}>
            {(originObj && originObj.Origin ? originObj.Origin : '')} - {(destinationObj && destinationObj.Destination ? destinationObj.Destination : '')}
          </small>
        </div>
      )

      return (
        <div
          className='d-flex align-items-center justify-content-center'
          style={{
            background: 'linear-gradient(90deg, #d0f0fd 0%, #f3d9fa 100%)',
            padding: '10px 20px',
            borderRadius: '16px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
          }}
        >
          <div className='text-center me-3'>
            <h6 className='mb-0 fw-bold' style={{ color: '#007bff', fontSize: '12px' }}>
              {(segmentStarting && segmentStarting.Origin && segmentStarting.Origin.Airport && segmentStarting.Origin.Airport.AirportCode) || ''}
            </h6>
            <small className='d-block text-muted' style={{ fontSize: '11px' }}>
              {(segmentStarting && segmentStarting.Origin && segmentStarting.Origin.Airport && segmentStarting.Origin.Airport.CityName) || ''}
            </small>
          </div>

          {stopsComponent}

          <div className='text-center ms-3'>
            <h6 className='mb-0 fw-bold' style={{ color: '#28a745', fontSize: '12px' }}>
              {(lastSegment && lastSegment.Destination && lastSegment.Destination.Airport && lastSegment.Destination.Airport.AirportCode) || ''}
            </h6>
            <small className='d-block text-muted' style={{ fontSize: '11px' }}>
              {(lastSegment && lastSegment.Destination && lastSegment.Destination.Airport && lastSegment.Destination.Airport.CityName) || ''}
            </small>
          </div>
        </div>
      )
    }

    const columns = [
      {
        title: '#',
        key: '_id',
        dataIndex: '_id',
        width: 50,
        render: (ite, record, index) => {
          return (
            <React.Fragment>
              {index + 1}
            </React.Fragment>
          )
        }
      },
      {
        title: 'Agent Name',
        dataIndex: 'name',
        key: 'name',
        width: 120,
        render: (item, record) => {
          return (
            <ColumnWidth width={120}>{item && `${item}(${record.companyName})`}</ColumnWidth>
          )
        }
      },
      {
        title: 'Passenger',
        dataIndex: 'Passengers',
        key: 'Passengers',
        width: 120,
        render: (item, record) => {
          return (
            <ColumnWidth width={120}>
              {item[0].FirstName}<br />
              <div className={'btn btn-default xs roundNew'}>
                PNR - {record && record.response && record.response.PNR ? record.response.PNR : ''}
              </div>
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Booking Date',
        dataIndex: 'createdAt',
        key: 'createdAt',
        width: 120,
        render: (item) => {
          return (
            <ColumnWidth width={120}>{displayDate(item)}</ColumnWidth>
          )
        }
      },
      {
        title: 'Flight Details',
        dataIndex: 'response',
        key: 'response',
        width: 250,
        render: (item, record) => {
          let segments = []
          let quoteFare = []
          let { fareQuote } = record
          if (fareQuote && fareQuote.Segments && fareQuote.Segments.length) {
            segments = fareQuote.Segments[0] || []
            quoteFare = fareQuote
          }
          return (
            <ColumnWidth width={250}>
              {segments && segments.length ?
                <div className={'flight-detail'}>
                  {segments.length > 1 ?
                    <FlightStopsComponent data={quoteFare} item={item} record={record} /> :
                    <FlightNonStopComponent data={quoteFare} item={item} record={record} />}
                </div> : null
              }
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Agent Ticket Details',
        dataIndex: 'xtravelMarginData',
        key: 'xtravelMarginData',
        width: 250,
        render: (item, record) => {
          const convinceFees = Number(record && record.convinceFees) || 0
          const netAmount = Number(item && item.netAmount) || 0
          const agentPaidAmt = netAmount - convinceFees
          return (
            <ColumnWidth width={100}>
              <div>
                <div>
                  Ticket Amount : Rs. {item && item.netAmount && fixed2Digit(item.netAmount)}
                </div>
                <div>
                  Agent Margin: Rs {fixed2Digit(convinceFees)}
                </div>
                <div className={'mt5'}>
                  <label className={'label label-primary'}>
                    Agent Paid Amount Rs. {agentPaidAmt}
                  </label>
                </div>
              </div>

            </ColumnWidth>
          )
        }
      },
      {
        title: 'Net Paid To TBO',
        dataIndex: 'response',
        key: 'response',
        width: 120,
        render: (item, record) => {
          const invoiceList = item &&
            item.FlightItinerary &&
            item.FlightItinerary.Invoice &&
            item.FlightItinerary.Invoice
          const total = Array.isArray(invoiceList)
            ? invoiceList.reduce((total, invoice) => {
              return total + (Number(invoice.InvoiceAmount) || 0)
            }, 0) : 0
          return (
            <ColumnWidth width={120}>
              {record.invoiceAmount ?
                <div className={'label label-default'}>
                  Rs. {record.invoiceAmount}
                </div> : total != 0 ?
                  <div className={'label label-default'}>
                    Rs. {total}
                  </div> : <div className={'label label-default'}>
                    Rs. 0
                  </div>
              }
            </ColumnWidth>
          )
        }
      },

      {
        title: 'Total Profit',
        dataIndex: 'xtravelMarginData',
        key: 'xtravelMarginData',
        width: 200,
        render: (item, record) => {
          const flightItinerary = record && record.response && record.response.FlightItinerary
          const invoiceList = flightItinerary && flightItinerary.Invoice

          let tboAmt = 0
          if (Array.isArray(invoiceList)) {
            tboAmt = invoiceList.reduce((total, invoice) => {
              return total + (Number(invoice && invoice.InvoiceAmount) || 0)
            }, 0)
          }

          const convinceFees = Number(record && record.convinceFees) || 0
          const netAmount = Number(item && item.netAmount) || 0
          const agentPaidAmt = netAmount - convinceFees

          const xTravelMargin = Number(item && item.xTravelMargin) || 0
          const xTravelMarginGst = Number(item && item.gstOnXTravelMargin) || 0

          const totalProfit = agentPaidAmt - xTravelMargin - xTravelMarginGst - tboAmt


          return (
            <ColumnWidth width={120}>
              <span className={(totalProfit + xTravelMargin) < 0 ? 'badge bg-danger' : 'badge bg-success'}>
               Total Profit:  Rs. {fixed2Digit(totalProfit + xTravelMargin)}
              </span><br />
              X-margin: Rs. {fixed2Digit(xTravelMargin)} <br />
              TBO-comm.: Rs. {fixed2Digit(totalProfit)}
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Gst',
        dataIndex: 'xtravelMarginData',
        key: 'xtravelMarginData',
        width: 120,
        render: (item) => {
          return (
            <ColumnWidth
              width={120}>Rs. {item && item.gstOnXTravelMargin && fixed2Digit(item.gstOnXTravelMargin)}</ColumnWidth>
          )
        }
      }
    ]
    const filterBlock = (
      <Row gutter={16}>
        <Col md={4} sm={4} xs={8} lg={4}>
          <div className='sort-box-table custom-sort-box-new'>

            <AgentTypeheadComponent
              key={this.state.filterAgentId}
              agentId={this.state.filterAgentId}
              dispatch={this.props.dispatch}
              customStyle={''}
              onSelect={item => {
                this.setState({
                  filterAgentId: item
                })
              }}
            />
          </div>
        </Col>
        <Col md={4} sm={4} xs={8} lg={4}>
          <div className='sort-box-table custom-sort-box-new'>
            <RangePicker
              className={'form-control'}
              value={
                this.state.fromDate && this.state.toDate
                  ? [this.state.fromDate, this.state.toDate]
                  : []
              }
              onChange={(val) => {
                this.setState({
                  fromDate: val && val[0] ? val[0] : null,
                  toDate: val && val[1] ? val[1] : null
                })
              }}
            />
          </div>
        </Col>

        <Col md={4} sm={4} xs={8} lg={4}>
          <Button onClick={() => searchFxn()} className={'roundBtn'}>
            Search
          </Button>
          <Button onClick={() => clearFxn()} className={'roundBtn'}>
            Clear
          </Button>
        </Col>
      </Row>
    )
    const apiRequest = (params) => {
      let { dispatch } = this.props
      return new Promise(async (resolve) => {
        if (this.state.filterAgentId) {
          params.userId = this.state.filterAgentId
        }
        if (this.state.fromDate || this.state.toDate) {
          params.createdAt = {}
          if (this.state.fromDate) {
            params.createdAt.$gte = moment(this.state.fromDate).startOf('day').toISOString()
          }
          if (this.state.toDate) {
            params.createdAt.$lte = moment(this.state.toDate).endOf('day').toISOString()
          }
        }

        let { data } = await dispatch(getXTravelProfitAndLossFxn({
          ...params
        }))
        this.setState({
          total: data.total,
          totalProfit: data.totalProfit,
          totalGstOnXTravelMarginData: data.totalGstOnXTravelMarginData
        })
        resolve(data)
      })
    }


    const getParamsForApplicationList = () => {
      return new Promise(resolve => {
        let searchParams = new URLSearchParams(window.location.search)
        let agentId = searchParams.get('agentId')
        let obj = {}
        if (agentId) {
          obj.agentId = agentId
        }
        resolve(obj)
      })
    }

    const searchFxn = async () => {
      let resp = await getParamsForApplicationList()
      let obj = {}
      if (resp.agentId) {
        obj.agentId = resp.agentId
      }
      this.props.dispatch(
        getUrlPushWrapper('xTravelWorldProfitAndLoss', {
          ...obj
        })
      )
      setTimeout(() => {
        if (this.tableRef.current && this.tableRef.current) {
          this.tableRef.current.reload()
        }
      }, 200)
    }
    const clearFxn = async () => {
      let obj = {}
      this.setState({
        filterAgentId: '',
        fromDate: '',
        toDate: ''
      })
      this.props.dispatch(
        getUrlPushWrapper('xTravelWorldProfitAndLoss', {
          ...obj
        })
      )
      setTimeout(() => {
        this.tableRef.current.reload()
      }, 200)
    }

    return (
      <div>

        <div className='row  mt-4' id='creditLimitTable'>
          <div className='col-lg-12'>
            <div className='card'>
              <div className='table-head d-flex align-items-center'>
                <h5>XTravelWorld Profit & Loss (Total :{total})</h5>
              </div>
              <div className='card-body table-responsive'>
                {filterBlock}
                <div className='text-end'>
                  <div className='fw-bold fs-5 text-primary'>
                    Total Profit Earned:&nbsp;
                    <span className='text-dark'>
                      Rs. {Number(this.state.totalProfit).toLocaleString('en-IN')}
                    </span>
                  </div>
                  <div className='fw-bold fs-6 text-success mt-1'>
                    Total GST Collected on XTravel Margin:&nbsp;
                    <span className='text-dark'>
                      Rs. {Number(this.state.totalGstOnXTravelMarginData).toLocaleString('en-IN')}
                    </span>
                  </div>
                </div>

                <TableComp columns={columns}
                           ref={this.tableRef}
                           pagination={DefaultTablePagination()}
                           apiRequest={apiRequest}
                           extraProps={{ scroll: { x: 1000 } }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>)

  }
}


const mapStateToProps = ({ global }) => ({
  categories: global.categories,
  currentUser: global.currentUser

})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(xTravelWorldProfitAndLoss)
